import { operators as o } from '@pendo/aggregations';
import { PRODUCT_AREAS, SUB_PRODUCT_AREAS } from '@/utils/aggregation';

const { VOC } = PRODUCT_AREAS || {};
const { CAPTURE } = SUB_PRODUCT_AREAS || {};

export default {
    name: 'LabelAssociatedItemCounts',
    productArea: VOC,
    subProductArea: CAPTURE,
    responseFormat: 'rows',
    build: () => {
        const pipeline = o.pipeline(
            o.spawn(
                o.pipeline(
                    o.sources.vocItems({
                        type: 'idea',
                        appId: 'expandAppIds("*")',
                    }),
                ),
                o.pipeline(
                    o.sources.vocItems({
                        type: 'feedback',
                        appId: 'expandAppIds("*")',
                    }),
                ),
            ),
            o.select(['id', 'labelIds', 'type']),
            o.unwind('labelIds'),
            o.group(['labelIds', 'type'], o.groupField('count', o.count('id'))),
            o.select({ labelId: 'labelIds', type: 'type', count: 'count' }),
        );

        return pipeline;
    },
};
